import React from 'react';
import { Table, Button, Badge } from 'react-bootstrap';
import { FaEdit, FaTrash, FaEye } from 'react-icons/fa';

const LabTable = ({ labs, onEdit, onDelete, onView }) => {
  if (!labs || labs.length === 0) {
    return (
      <div className="text-center py-4">
        <p className="text-muted">No labs found.</p>
      </div>
    );
  }

  return (
    <div className="table-responsive">
      <Table striped bordered hover size="sm">
        <thead className="table-dark">
          <tr>
            <th>SN</th>
            <th>Lab Name</th>
            <th>Address</th>
            <th>Phone</th>
            <th>Email</th>
            <th>Default Collector</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {labs.map((lab, index) => (
            <tr key={lab._id}>
              <td>{index + 1}</td>
              <td>{lab.name}</td>
              <td>
                <span title={lab.address}>
                  {lab.address.length > 50 ? `${lab.address.substring(0, 50)}...` : lab.address}
                </span>
              </td>
              <td>{lab.contact?.phone || '-'}</td>
              <td>{lab.contact?.email || '-'}</td>
              <td>
                {lab.defaultCollector ? (
                  <span>
                    {lab.defaultCollector.name} - {lab.defaultCollector.mobile}
                  </span>
                ) : (
                  '-'
                )}
              </td>
              <td>
                <Badge bg={lab.isActive ? 'success' : 'secondary'}>
                  {lab.isActive ? 'Active' : 'Inactive'}
                </Badge>
              </td>
              <td>
                <div className="d-flex gap-1">
                  {onView && (
                    <Button
                      variant="outline-info"
                      size="sm"
                      onClick={() => onView(lab)}
                      title="View Details"
                    >
                      <FaEye />
                    </Button>
                  )}
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={() => onEdit(lab)}
                    title="Edit Lab"
                  >
                    <FaEdit />
                  </Button>
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => onDelete(lab)}
                    title="Delete Lab"
                  >
                    <FaTrash />
                  </Button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};

export default LabTable;
